module.exports = __webpack_public_path__ + "444928016652824da251488ed0c54365.svg";